(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("elfproef", [], factory);
	else if(typeof exports === 'object')
		exports["elfproef"] = factory();
	else
		root["elfproef"] = factory();
})(window, function() {
return 